<template>
	<div id="app">
		<!--<router-view />-->
		<Sign v-if="signature" />
		<Home v-else />
	</div>
</template>

<script>
	import { getUrlParams } from "./mixins/methods";

	import Home from "./views/Home.vue";
	import Sign from "./views/Sign.vue";

	export default {
		name: "App",
		components: {
			Home,
			Sign
		},
		data() {
			return { signature: false };
		},
		async created() {
			let { sign, hostnameAlias } = getUrlParams(window.location.search);

			if (sign) {
				this.signature = sign === "true" ? true : false;
			}

			/* --- Branding COLORS --- */
			const branding = await this.$store.dispatch("branding", { hostname_alias: hostnameAlias });
      this.$store.commit("branding", branding);
			if (branding && branding.colors) {
				const root = document.documentElement;

				for (const [key, value] of Object.entries(branding.colors)) {
					root.style.setProperty(`--${key}`, value);
				}
			}
		}
	};
</script>

<style></style>
